import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../firebaseConfig";
import { getSelectedUid } from "../../../../frontend/Recruitment/Applications/Utils/UidListener";


const readDataS3 = async () => {
  const userId = getSelectedUid(); // Get the selected UID
  if (!userId) {
    throw new Error("Invalid user.");
  }
  try {
    const docRef1 = doc(
      db,
      "Advisers",
      userId,
      "Application Details",
      "Life Assurance Companies"
    );
    const docRef2 = doc(
      db,
      "Advisers",
      userId,
      "Application Details",
      "Work History"
    );
    const docSnap1 = await getDoc(docRef1);
    const docSnap2 = await getDoc(docRef2);

    if (docSnap1.exists() && docSnap2.exists()) {
        return {
            lifeAssuranceCompanies: docSnap1.data(),
            workHistory: docSnap2.data(),
        };

    } else {
      // console.log("No such document for Section 3!");
      return null;
    }
  } catch (error) {
    // console.error("Error fetching Section 3 data: ", error);
    return null;
  }
};

export default readDataS3;
